import { ReminderContent } from '.';
import classNames from 'classnames';
import { scrollWindow } from 'events/scroll';
import { action, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./RemindersCenter.css');

// Component
@inject('store')
@observer
export class RemindersCenter extends React.Component<IAppOnlyStore, {}> {
    constructor(props: IAppOnlyStore) {
        super(props);

        // Scroll to the bottom of the container when reminders center opens
        reaction(
            () => this.props.store.activities.showRemindersCenter,
            show => {
                if (show && this.container) {
                    this.container.scrollTop = 99999;
                }
            }
        );
    }

    private container: HTMLDivElement | null = null;

    @observable private activeZIndex: number = 2;
    @observable private activeId: number | null = null;

    public render() {
        const { activities } = this.props.store;

        return (
            <div
                ref={this.referenceContainer}
                className={classNames(s.container, {
                    [s.show]: activities.showRemindersCenter,
                })}
                onClick={
                    activities.showRemindersCenter
                        ? this.handleContainerClick
                        : undefined
                }
            >
                <div className={s.center} onClick={this.handleCenterClick}>
                    {activities.activitiesToRemindAbout.length <= 0 && (
                        <div className={s.noReminders}>
                            <p>No reminders are currently pending.</p>
                        </div>
                    )}

                    {activities.activitiesToRemindAbout.map((activity, i) => (
                        <ReminderContent
                            key={activity.id}
                            activity={activity}
                            zIndex={
                                this.activeId === activity.id
                                    ? this.activeZIndex
                                    : 1
                            }
                            onSnoozeOptionsDropdownOpen={
                                this.handleSnoozeOptionsDropdownOpen
                            }
                            onSnoozeOptionSelected={
                                this.handleSnoozeOptionSelected
                            }
                            onGoToLeadClick={this.handleLeadClick}
                            onDismissReminder={this.handleReminderDismiss}
                            onMarkAsComplete={this.handleReminderMarkAsComplete}
                        />
                    ))}
                </div>
            </div>
        );
    }

    private referenceContainer = (ref: HTMLDivElement) =>
        (this.container = ref);

    @action private handleSnoozeOptionsDropdownOpen = (activityId: number) => {
        this.activeZIndex++;
        this.activeId = activityId;
    };

    private handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        this.props.store.activities.closeActivitiesReminders();
    };

    private handleCenterClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    private handleLeadClick = (leadId: number) => {
        if (this.props.store.lead.openLeadId === leadId) {
            scrollWindow.toY(0);
        } else {
            this.props.store.lead.handleLeadSelect(leadId);
        }
    };

    private handleReminderDismiss = (activityId: number) => {
        this.props.store.activities.disableActivityReminder(activityId);
    };

    private handleReminderMarkAsComplete = (activityId: number) => {
        this.props.store.activities.markActivityAsComplete(activityId);
    };

    private handleSnoozeOptionSelected = (
        activityId: number,
        remindInMinutes: number
    ) => {
        this.props.store.activities.delayActivityReminder(
            activityId,
            remindInMinutes
        );
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/reminder/RemindersCenter.tsx